import React, { memo } from 'react'
import clsx from 'clsx'
import { ListItem } from '@material-ui/core'
import PropTypes from 'prop-types'
import ItemBorder from '@v4/components/common/ItemBorder'
import Image from '@v4/components/common/Image'
import { useItem } from './Item.hooks'

const Item = props => {
	const [{ classes, itemKey, group, withImage, image }, { handleImageClick }] = useItem(props)

	return (
		<ItemBorder itemKey={itemKey} group={group}>
			<ListItem className={clsx(classes.root, 'Banner15-item')}>
				{withImage && (
					<Image
						className={clsx(classes.image, 'Banner15-image-item')}
						onClick={handleImageClick}
						metaData={image}
						isBackground
					/>
				)}
			</ListItem>
		</ItemBorder>
	)
}

Item.propTypes = {
	group: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	itemKey: PropTypes.string.isRequired,
	itemsCount: PropTypes.number.isRequired,
	isMobile: PropTypes.bool.isRequired,
}

export default memo(Item)
